import { Container } from "@bilar/ui";
import React from "react";
import {
	BasePageProps,
	RouteTransition,
	useAppTranslation,
} from "@bilar/common";
import {
	GetStaticProps,
	GetStaticPropsContext,
	GetStaticPropsResult,
} from "next";
import { getBasePagePropsData } from "@bilar/pages-common";
import { VehicleForm, VehicleFormProvider } from "@bilar/features";
import { routes } from "@bilar/config";

type NewAdPageProps = {} & BasePageProps;

const NewAdPage = (props: NewAdPageProps) => {
	const { t } = useAppTranslation();
	return (
		<RouteTransition>
			<VehicleFormProvider>
				<Container>
					<VehicleForm
						title={t("postNewAd")}
						signInReturnRoute={routes.vehicleClassifieds.new}
					/>
				</Container>
			</VehicleFormProvider>
		</RouteTransition>
	);
};

export const getStaticProps: GetStaticProps<NewAdPageProps> = async (
	ctx: GetStaticPropsContext,
): Promise<GetStaticPropsResult<NewAdPageProps>> => {
	// Get Locale and common translations
	const baseProps = await getBasePagePropsData(ctx);

	return {
		props: {
			...baseProps,
		},
		// we will attempt to re-generate the page:
		// - when a request comes in
		// - at most once every second
		//revalidate: 60,
	};
};

export default NewAdPage;
